import React, { Fragment } from 'react';
import { useAtom } from 'jotai';

import FilterContext from '../Context/FilterContext';
import ActiveFilter from './Filters/ActiveFilter';
import RecipeCard from './RecipeCard';

import { toggleFilterMenu } from '../utils/filters';

import { applyStateAtom, initialState, TAX_MAP } from '../utils/globals';
import { resetFastFilters, resetNavFilters } from '../utils/reset';

const Container = ({
    activeFiltersCounter,
    filterLinks,
    filterRef,
    activeFilters,
    setActiveFilters,
    setActiveFiltersCounter,
    makeAPICall,
    resultsCounter,
    resetFilters,
    results,
    hideLoadMore,
    loadMore,
}) => {
    const [applyState, setApplyState] = useAtom(applyStateAtom);

    function toggleFastFilter(event, filter) {
        const element = event.currentTarget;

        if (element.classList.contains('active')) {
            resetFastFilters();
            resetNavFilters(setActiveFilters, setActiveFiltersCounter, setApplyState);
        } else {
            const fastFilters = document.querySelectorAll('.js-fast-filter');

            for (let i = 0; i < fastFilters.length; i += 1) {
                fastFilters[i].classList.remove('active');
            }

            element.classList.add('active');

            const [taxonomy, idRaw, name] = filter.split('::');
            const id = parseInt(idRaw, 10);

            const filterID = TAX_MAP[taxonomy];

            // Reset the applyState to the initial state except for the current filter's value.
            setApplyState({
                ...initialState,
                [filterID]: [id],
            });

            console.info('filterID: ', filterID);
            console.info('id: ', id);

            const emptyArray = [];
            const newFilters = emptyArray.concat({ id: id, name: name, taxonomy: taxonomy });
            console.info('Active Filters: ', newFilters);

            setActiveFilters(newFilters);
            setActiveFiltersCounter(newFilters.length);
        }
    }

    function selectOrder(event) {
        applyState.orderby = event.target.value;
        setApplyState(applyState);
        makeAPICall();
    }

    return (
        <div className="b-recipes-advanced-filter__container">
            <div className="b-recipes-advanced-filter__inner-wrapper">
                <div className="inner-wrapper__row">
                    <div className="inner-wrapper__filter-controls">
                        <button
                            className="e-circle-button e-circle-button--carousel-button--dark e-circle-button--large"
                            type="button"
                            tabIndex="0"
                            aria-label="Search"
                            aria-disabled="false"
                            onClick={toggleFilterMenu}
                        >
                            <img className="e-circle-button__icon e-icon" src={'/wp-content/themes/electro/img/svg/search.svg'} alt={'Search'}/>
                            <span className="visuallyhidden"></span>
                        </button>

                        <button
                            className="e-button e-button--filled-on-white e-button--large legacyStyle"
                            type="button"
                            tabIndex="0"
                            aria-label="Filter"
                            aria-disabled="false"
                            onClick={toggleFilterMenu}
                        >
                            <img className="e-button__icon" src="/wp-content/themes/electro/img/svg/icon-sort.svg" />
                            <span className="e-button__copy">Filter</span>
                        </button>
                    </div>
                    <div className="inner-wrapper__sort">
                        <Fragment>
                            <select
                                className="e-select recipe-filter-select"
                                onChange={selectOrder}
                                value={applyState?.orderby}
                            >
                                <option value="&orderby=date&order=desc">Order by Date (Newest)</option>
                                <option value="&orderby=date&order=asc">Order by Date (Oldest)</option>
                                <option value="&orderby=title&order=asc">Order by Title (A-Z)</option>
                                <option value="&orderby=title&order=desc">Order by Title (Z-A)</option>
                                <option value="&orderby=rating&order=desc">Order by Rating (High to Low)</option>
                            </select>
                        </Fragment>
                    </div>
                </div>

                <div className="inner-wrapper__row">
                    <div className="inner-wrapper__filters">
                        <Fragment>
                            <span className="filters__title">Popular Filters</span>

                            {filterLinks.map((option, index) => (
                                <button
                                    key={index}
                                    className="e-button js-fast-filter"
                                    data-filter={option.filter_value}
                                    onClick={(e) => toggleFastFilter(e, option.filter_value)}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </Fragment>
                    </div>
                </div>
            </div>

            <div ref={filterRef} className="b-recipes-advanced-filter__results-wrapper">
                <FilterContext.Provider
                    value={{ activeFilters, setActiveFilters, setActiveFiltersCounter, makeAPICall }}
                >
                    {activeFiltersCounter > 0 && (
                        <Fragment>
                            <div className="b-recipes-advanced-filter__results-wrapper__summary">
                                <h3>{resultsCounter} Recipes</h3>
                            </div>
                            <div className="b-recipes-advanced-filter__results-wrapper__active-filters">
                                <div className="active-filters__wrapper">
                                    {activeFilters.map((activeFilter, index) => (
                                        <ActiveFilter
                                            name={activeFilter.name}
                                            key={index}
                                            id={activeFilter.id}
                                            makeAPICall={makeAPICall}
                                            taxonomy={activeFilter.taxonomy}
                                        />
                                    ))}
                                </div>

                                <button
                                    className="e-button e-button--outlined-light e-button--large button--clear-filters"
                                    type="button"
                                    tabIndex="0"
                                    aria-label="Filter"
                                    aria-disabled="false"
                                    onClick={resetFilters}
                                >
                                    <span className="e-button__copy">Clear Filters</span>
                                </button>
                            </div>
                        </Fragment>
                    )}
                </FilterContext.Provider>
                <div className="b-recipes-advanced-filter__results-wrapper__list-wrapper">
                    {results.map(
                        ({
                            id,
                            // eslint-disable-next-line camelcase
                            icon_name,
                            icon = icon_name,
                            banner_color = banner_color,
                            rating = 0,
                            link: url,
                            recipe: { image_url: image, name },
                        }) => (
                            <RecipeCard
                                key={id}
                                banner_color={banner_color}
                                icon={icon}
                                image={image}
                                rating={rating}
                                url={url}
                                name={name}
                            />
                        )
                    )}
                </div>

                <div className="b-recipes-advanced-filter__results-wrapper__load-more-wrapper">
                    {!hideLoadMore && (
                        <button
                            type="button"
                            className="e-button e-button--filled-on-white e-button--large legacyStyle"
                            onClick={loadMore}
                        >
                            <span className="e-button__copy">Load More Recipes</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
export default Container;
